module.exports = __webpack_public_path__ + "img/client-6-2.3bbe8359.png";